<template>
  <el-row>
    <el-row class="column-name" justify="start">
      <span>操作设备参数</span>
      <div class="navbar-right">
        <el-button type="info" plain size="minimum" @click="toAddOperate" :disabled="!addable">新增</el-button>
      </div>
    </el-row>
    <el-row class="bottom20">
      <job-plan-spec-list ref="operateJobPlanSpecList" :type="'OPERATE'" :job-plan-id="jobPlanId"
                          :addable="addable" :updatable="updatable" :deletable="deletable"></job-plan-spec-list>
    </el-row>

    <el-row class="column-name" justify="start">
      <span>检查设备参数</span>
      <div class="navbar-right">
        <el-button type="info" plain size="minimum" @click="toAddCheck" :disabled="!addable">新增</el-button>
      </div>
    </el-row>
    <el-row>
      <job-plan-spec-list ref="checkJobPlanSpecList" :type="'CHECK'" :job-plan-id="jobPlanId"
                          :addable="addable" :updatable="updatable" :deletable="deletable"></job-plan-spec-list>
    </el-row>

    <el-dialog :visible.sync="jobPlanSpecAddDialogVisible" width="70%">
      <job-plan-spec-add ref="jobPlanSpecAdd"
                         :job-plan-id="jobPlanId"
                         :operate-exist="operateExist"
                         :check-exist="checkExist"
                         @success="jobPlanSpecAddSuccess"
      ></job-plan-spec-add>
      <div slot="footer" class="dialog-footer">
        <el-row>
          <el-button @click="jobPlanSpecAddDialogVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="save" size="small">保 存</el-button>
        </el-row>
      </div>
    </el-dialog>
  </el-row>
</template>

<script>
  import JobPlanSpecList from './jobplanspec/list'
  import JobPlanSpecAdd from './jobplanspec/add'
  export default {
    name: "OperateParam",
    components: {
      JobPlanSpecList,
      JobPlanSpecAdd,
    },
    props: {
      jobPlanId: {},
      addable: {
        type: Boolean,
        default: false,
      },
      updatable: {
        type: Boolean,
        default: false,
      },
      deletable: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        jobPlanSpecAddDialogVisible: false,
        operateExist: false,
        checkExist: false,
      };
    },
    methods: {
      toAddOperate() {
        this.jobPlanSpecAddDialogVisible = true;
        this.operateExist = true;
        this.checkExist = false;
      },
      toAddCheck() {
        this.jobPlanSpecAddDialogVisible = true;
        this.operateExist = false;
        this.checkExist = true;
      },
      save() {
        this.$refs['jobPlanSpecAdd'].submit();
      },
      jobPlanSpecAddSuccess(event) {
        // console.log(`jobPlanSpecAddSuccess`, event);
        this.jobPlanSpecAddDialogVisible = false;
        this.$refs['jobPlanSpecAdd'].clear();
        this.refresh();
      },
      refresh() {
        this.$refs['operateJobPlanSpecList'].refresh();
        this.$refs['checkJobPlanSpecList'].refresh();
      }
    },
  }
</script>

<style scoped>

</style>